import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getMarkSchemesBySubject() {
  try {
    yield put(actions.addMarkSchemeLoading(true));
    const result = yield call(api.getMarkSchemesBySubject);
    yield put(actions.getMarkSchemesBySubjectSuccess(result.data));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to load mark schemes");
    yield put(actions.getMarkSchemesBySubjectFail());
  } finally {
    yield put(actions.addMarkSchemeLoading(false));
  }
}

function* createMarkScheme(formData) {
  try {
    yield put(actions.addMarkSchemeLoading(true));
    yield call(api.createMarkScheme, formData.payload);
    toast.success("Created Successfully");
    formData?.action && formData.action();
    // store() currently does not return the created model — refresh the list
    const result = yield call(api.getMarkSchemesBySubject);
    yield put(actions.getMarkSchemesBySubjectSuccess(result.data));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to create mark scheme");
    yield put(actions.createMarkSchemeFail());
  } finally {
    yield put(actions.addMarkSchemeLoading(false));
  }
}

function* registerMarkScheme({ payload }) {
  try {
    yield put(actions.addMarkSchemeLoading(true));
    const result = yield call(api.registerMarkScheme, payload);
    yield put(
      actions.registerMarkSchemeSuccess({
        url: payload?.url,
        data: result.data,
      })
    );
    toast.success("Registered Successfully");
  } catch (error) {
    const details = error?.response?.data;
    toast.error(
      details?.error ||
        details?.message ||
        "Failed to register mark scheme"
    );
    yield put(actions.registerMarkSchemeFail());
  } finally {
    yield put(actions.addMarkSchemeLoading(false));
  }
}

export default function* MarkSchemeSaga() {
  yield takeLatest(Types.GET_MARK_SCHEMES_REQUEST, getMarkSchemesBySubject);
  yield takeLatest(Types.CREATE_MARK_SCHEME_REQUEST, createMarkScheme);
  yield takeLatest(Types.REGISTER_MARK_SCHEME_REQUEST, registerMarkScheme);
}
